<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { cn } from 'dashboard/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  open?: boolean
}>()

const emit = defineEmits<{ 'update:open': [value: boolean] }>()
</script>

<template>
  <Teleport to="body">
    <div v-if="open" class="fixed inset-0 z-50 flex items-center justify-center">
      <!-- Backdrop -->
      <div class="fixed inset-0 bg-black/50" @click="emit('update:open', false)" />
      <!-- Content -->
      <div :class="cn('relative z-50 w-full max-w-lg gap-4 border border-[hsl(var(--border))] bg-[hsl(var(--background))] p-6 shadow-lg rounded-lg sm:rounded-lg', props.class)">
        <slot />
      </div>
    </div>
  </Teleport>
</template>
